module.exports = __webpack_public_path__ + "img/noticia_interna.31f8058b.png";